import React, { Component } from "react";
import { Layout, Breadcrumb, Button, PageHeader, notification } from "antd";
import { RightOutlined } from "@ant-design/icons";
import PatientTable from "./PatientTable";
import PatientForm from "./PatientForm";

import { getOne as getPatient, remove as removePatient } from "../../api/Patient";
import { GlobalContext } from "../../GlobalContext";

const { Content } = Layout;

/**
 *
 */
class SurgicalIntervention extends Component {
  static contextType = GlobalContext;
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      PatientToEdit: null,
    };

    this.patientsTable = React.createRef();

    this.onCreatedHandler = this.onCreatedHandler.bind(this);
    this.onEditHandler = this.onEditHandler.bind(this);
    this.onDeleteHandler = this.onDeleteHandler.bind(this);
    this.onAddHandler = this.onAddHandler.bind(this);
  }

  /**
   *
   */
  onCreatedHandler = () => {
    this.patientsTable.current.fetch({
      current: 1,
      pageSize: 10,
    });

    this.setState({
      showForm: false,
    });
  };

  /**
   *
   */
  onAddHandler = () => {
    this.setState({
      showForm: true,
    });
  };

  onEditHandler = async (patientId) => {
    getPatient(patientId).then((data) => {
      this.setState({
        showForm: true,
        PatientToEdit: data,
      });
    });
  };

  onDeleteHandler = async (patientId) => {
    removePatient(patientId).then((data) => {
      this.patientsTable.current.fetch({
        current: 1,
        pageSize: 10,
      });
    }).catch(() => {
      notification['error']({ message: 'Impossible de supprimer le patient. Ce patient peut faire l\'objet d\'un séjour enregistré.' });
    });
  };

  render() {

    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Listing Patients</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          title="Listing Patients"
          extra={[
            <Button
              key="add"
              type="primary"
              size="large"
              onClick={this.onAddHandler}
            >
              Nouveau patient
            </Button>,
          ]}
        />
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <PatientTable
            ref={this.patientsTable}
            onEdit={this.onEditHandler}
            onDelete={this.onDeleteHandler}
          />
          <PatientForm
            onCreated={this.onCreatedHandler}
            onClose={() => {
              this.setState({
                showForm: false,
                PatientToEdit: null,
              });
            }}
            visible={this.state.showForm}
            patient={this.state.PatientToEdit}
          />
        </div>
      </Content>
    );
  }
}

export default SurgicalIntervention;
